import type { MouseEvent } from 'react';
import { StyledCardSelectButton } from './CardSelectButton.styles';
import type { CardSelectButtonProps } from './CardSelectButton.types';

const opensElsewhere = (event: MouseEvent) =>
  event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;

export function CardSelectButton({
  children,
  onSelect,
  href,
  'aria-label': ariaLabel,
  'aria-pressed': ariaPressed,
}: CardSelectButtonProps) {
  return (
    <StyledCardSelectButton
      as={href ? 'a' : 'button'}
      href={href}
      type={href ? undefined : 'button'}
      data-card-select=""
      aria-label={ariaLabel}
      aria-pressed={href ? undefined : ariaPressed}
      onClick={(event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        if (href && opensElsewhere(event)) return;
        event.preventDefault();
        onSelect();
      }}
    >
      {children}
    </StyledCardSelectButton>
  );
}
